import { HeartIcon as PhosphorHeartIcon } from "@phosphor-icons/react/dist/ssr/Heart";

import { createAppIcon } from "@/components/createAppIcon";

export const WishlistIcon = /* @__PURE__ */ createAppIcon(PhosphorHeartIcon);
export const WishlistFilledIcon = /* @__PURE__ */ createAppIcon(PhosphorHeartIcon, "fill");
export const FavoriteIcon = WishlistIcon;
export const FavoriteFilledIcon = WishlistFilledIcon;
